import {
  IPromoAction,
  IPromoWidgetProps,
} from "../components/DataDisplay/PromoWidget/PromoWidget.interface";
import {
  IVideoWidgetProps,
  IMediaBuilderProps,
  IImageData,
  TImageData,
} from "../components";

export const promoRandomPictureSources: IImageData["sources"] = [
  {
    srcset: "assets/images/widget/promo-banner-transparent.png",
    media: "(min-width: 1200px)",
  },
  {
    srcset: "assets/images/widget/promo-banner-single.png",
    media: "(min-width: 800px)",
  },
];

export const promoLargeImageData: TImageData = {
  type: "image",
  data: {
    src: "assets/images/widget/promo-banner.png",
    alt: "",
  },
};

export const promoDataBase: IPromoWidgetProps = {
  type: "default",
  size: "large",
  id: "1",
  link: { href: "/promo/1" },
  iconMediaData: {
    type: "svg-icon",
    data: {
      icon: "NikeIcon",
    },
  },
  heading: "heading",
  title:
    "TUS PRODUCTOS DE ESQUÍ EN NUESTRAS TIENDAS ESPECIALISTAS TUS PRODUCTOS DE ESQUÍ EN NUESTRAS TIENDAS ESPECIALISTAS ESPECIALISTAS ESPECIALISTAS",
  description:
    "Discover gear from the National Team Discover gear from the National Team Discover gear from the National Team Discover gear from the National Team Discover gear from the National Team Discover gear from the National Team Discover gear from the National Team Discover gear from the National Team",
  mediaData: promoLargeImageData,
  actions: [],
};

/*
// Some greek text to check overflow (or font face)
title: "Τα φιλικά sms του Ρωμανού στον παρουσιαστή για τα αποθεωτικά αφιερώματα σε υπουργούς",
*/

export const promoDataActions: IPromoAction[] = [
  {
    id: "1",
    text: "shop men",
    link: {
      href: "/promo/1/men",
    },
    onClick: () => {
      console.log("click men");
    },
  },
  {
    id: "2",
    text: "shop women",
    link: {
      href: "/promo/1/women",
    },
    onClick: () => {
      console.log("click women");
    },
  },
  {
    id: "3",
    text: "shop kids",
    link: {
      href: "/promo/1/kids",
    },
    onClick: () => {
      console.log("click kids");
    },
  },
];

const { iconMediaData: bn2, description: d2, ...restPromo2 } = promoDataBase;
export const promoDataNoDescription = {
  ...restPromo2,
  iconMediaData: bn2,
};
export const promoDataNoBrandNoDescription = {
  ...restPromo2,
  heading: "new-in",
  title: "EVERYTHING FOR THE BEST running EXPERIENCE",
};

export const promoDataNoBrandNoDescriptionCarousel = [
  {
    id: "0",
    heading: "new-in",
    mediaData: promoLargeImageData,
    title: "EVERYTHING FOR THE BEST running EXPERIENCE",
    actions: [
      {
        id: "1",
        link: {
          href: "/promo/1/men",
        },
        text: "shop men",
      },
    ],
  },
  {
    id: "1",
    heading: "new-in",
    mediaData: promoLargeImageData,
    title: "EVERYTHING FOR THE BEST running EXPERIENCE",
    actions: [
      {
        id: "1",
        link: {
          href: "/promo/1/men",
        },
        text: "shop men",
      },
    ],
  },
  {
    id: "2",
    heading: "new-in",
    mediaData: promoLargeImageData,
    title: "EVERYTHING FOR THE BEST running EXPERIENCE",
    actions: [
      {
        id: "1",
        link: {
          href: "/promo/1/men",
        },
        text: "shop men",
      },
    ],
  },
  {
    id: "3",
    heading: "new-in",
    mediaData: promoLargeImageData,
    title: "EVERYTHING FOR THE BEST running EXPERIENCE",
    actions: [
      {
        id: "1",
        link: {
          href: "/promo/1/men",
        },
        text: "shop men",
      },
    ],
  },
];

export const promoFadedMediaData: IMediaBuilderProps = {
  type: "image",
  data: {
    src: "assets/images/widget/promo-banner-single.png",
  },
};

export const promoVideoData: IVideoWidgetProps = {
  sources: [{ src: "assets/video/Forest.mp4" }],
  poster: "assets/images/widget/promo-banner-transparent.png",
  classes: {
    /** clears "position-relative" */
    root: "",
    video: "position-absolute start-0 top-0 w-100 h-100 object-fit-cover",
  },
};

export const promoVideoDataNonAbs: IVideoWidgetProps = {
  sources: [{ src: "assets/video/Forest.mp4" }],
  poster: "assets/images/widget/promo-banner-transparent.png",
  classes: {
    /** clears "position-relative" */
    root: "position-relative",
    video: "position-relative w-100 h-100 object-fit-cover",
  },
};

export const promoVideoMediaData: IMediaBuilderProps = {
  type: "video",
  data: {
    ...promoVideoData,
  } as IVideoWidgetProps,
};

export const promoVideoMediaDataNonAbs: IMediaBuilderProps = {
  type: "video",
  data: {
    ...promoVideoDataNonAbs,
  } as IVideoWidgetProps,
};
